import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router';
import { PageLoader } from '@dezza/ui';

const TeamPage = lazy(() => import('./TeamPage'));
const MemberPage = lazy(() => import('./MemberPage'));

/** Rotas desta área (dentro do shell autenticado). */
export const routes: RouteObject[] = [
  {
    path: 'usuarios',
    element: (
      <Suspense fallback={<PageLoader />}>
        <TeamPage />
      </Suspense>
    ),
  },
  {
    path: 'usuarios/:id',
    element: (
      <Suspense fallback={<PageLoader />}>
        <MemberPage />
      </Suspense>
    ),
  },
];

/** Rotas protegidas sem o shell (ex.: impressão). */
export const fullscreenRoutes: RouteObject[] = [];
